export const GET_JOB_TITLES_REQUEST = 'GET_JOB_TITLES_REQUEST';
export const GET_JOB_TITLES_SUCCESS = 'GET_JOB_TITLES_SUCCESS';
export const GET_JOB_TITLES_FAILURE = 'GET_JOB_TITLES_FAILURE';
